var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-skeleton-container"},[_c('MainGridSkeleton',_vm._l((_vm.count),function(ref){
var id = ref.id;
return _c('MainGridItemSkeleton',{key:id})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }